import { EVENTS_IMAGES } from './constants';

export const formatEventPassOffers = (offers) => {
    return (offers || []).map((offer) => {
        return {
            ...offer,
            ImageURL: EVENTS_IMAGES[offer?.EventType] || '',
        };
    });
};

export const formatNumber = (number) => {
    let formattedNumber = number.toLocaleString();
    formattedNumber = formattedNumber.replace(/,/g, " ");

    return formattedNumber;
};

export const verifyMilestoneHashAndGetId = (hash) => {
    const regex = /#milestone(\d+)/;
    const match = hash.match(regex);
    if (match[0]) {
        const regex = /^#/;
        return match[0].replace(regex, "");
    } else {
        return null;
    }
}

export const hasMilestonesToClaimLeft = (milestones) => {
    return milestones.some((milestone) => {
        return !milestone.Claimed && (milestone.CollectedWarTokens >= milestone.RequiredTokens);
    });
}

/**
 * Standart validation
 * @param {string} email
 * @returns boolean
 */
export const validateEmail = (email) => {
    if (!email.trim().length) {
        return null;
    }

    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        );
};

export const getDeviceType = () => {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
	if (/android/i.test(userAgent)) {
	  return 'android';
	}
  
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	  return 'ios';
	}
  
	return 'unknown';
};

// determine the launch context
export const isStandaloneApp = () => {
	return 	window.matchMedia('(display-mode: standalone)').matches ||
			window.navigator.standalone ||
			document.referrer.includes('android-app://');
};


// Google Analytics
/**
 * Google Analytics tracking functions
 * These functions are used to track page views and events in Google Analytics.
 * Make sure to replace 'G-XXX' with your actual Google Analytics tracking ID.
 *
 * @param {string} pagePath - The path of the page to track.
 * @param {string} pageTitle - The title of the page to track.
 */
export const trackPageView = (pagePath, pageTitle) => {
	if (typeof window !== 'undefined' && window.gtag) {
		window.gtag('config', 'G-GPPBR7ZX6F', {
			page_path: pagePath,
			page_title: pageTitle
		});
	}
};

/**
 * Tracks an event in Google Analytics.
 * This function is used to track custom events in Google Analytics.
 *
 * @param {string} eventName - The name of the event to track.
 * @param {object} params - The parameters of the event to track.
 */
export const trackEvent = (eventName, params) => {
	if (typeof window !== 'undefined' && window.gtag) {
		window.gtag('event', eventName, params);
	}
};

/**
 * Tracks a screen view in Google Analytics.
 * This function is used to track screen views in Google Analytics.
 */
export const trackViewOfferList = () => {
	trackEvent('view_offer_list', {
		event_category: 'Offers',
		event_label: 'All Offers'
	});
};


/**
 * Tracks a screen view in Google Analytics.
 * This function is used to track screen views in Google Analytics.
 *
 * @param {object} offer - The offer object to track.
 */
export const trackViewOfferDetails = (offer) => {
	trackEvent('view_offer_details', {
		event_category: 'View Item',
		event_label: offer.OfferId,
		items: [
			{
				currency: offer.currency,
				price: offer.NewPrice,
				name: offer.Name,
				id: offer.OfferId,
				category: offer.Category,
				type: offer.Type,
			}
		]
	});
};

/**
 * Tracks a purchase in Google Analytics.
 * This function is used to track purchases in Google Analytics.
 *
 * @param {object} offer - The offer object to track.
 */
export const trackAbandonOfferDetails = (offer) => {
	trackEvent('abandon_offer_details', {
		event_category: 'View Item',
		event_label: offer.OfferId,
		items: [
			{
				currency: offer.currency,
				price: offer.NewPrice,
				id: offer.OfferId,
				category: offer.Category,
				type: offer.Type,
			}
		]
	});
};

/**
 * Tracks a purchase in Google Analytics.
 * This function is used to track purchases in Google Analytics.
 *
 * @param {object} offer - The offer object to track.
 */
export const trackBeginCheckout = (offer) => {
	trackEvent('begin_checkout', {
		event_category: 'Checkout',
		event_label: offer.OfferId,
		items: [
			{
				currency: offer.currency,
				price: offer.NewPrice,
				name: offer.Name,
				id: offer.OfferId,
				category: offer.Category,
				type: offer.Type,
			}
		]
	});
};

/**
 * Tracks a purchase in Google Analytics.
 * This function is used to track purchases in Google Analytics.
 *
 * @param {object} offer - The offer object to track.
 */
export const trackAbandonCheckout = (offer) => {
	trackEvent('abandon_checkout', {
		event_category: 'Checkout',
		event_label: offer.name
	});
};

/**
 * Tracks a purchase in Google Analytics.
 * This function is used to track purchases in Google Analytics.
 *
 * @param {string} userId - The user ID to track.
 */
export const setUserData = (userId) => {
	// set user ID in Google Analytics
	window.gtag('config', 'G-GPPBR7ZX6F', {
		user_id: userId
	});
};

/**
 * Tracks a purchase in Google Analytics.
 * This function is used to track purchases in Google Analytics.
 *
 * @param {string} userId - The user ID to track.
 * @param {string} userType - Additional property to track.
 */
export const setUserDataProperties = (userId, userType) => {
	// set user ID in Google Analytics
	window.gtag('set', 'user_properties', {
		user_id: userId,
		user_type: userType,
	});
};

export const GA = {
	trackPageView,
	trackEvent,
	trackViewOfferList,
	trackViewOfferDetails,
	trackAbandonOfferDetails,
	trackBeginCheckout,
	trackAbandonCheckout,
	setUserData,
	setUserDataProperties,
	hasUserSawTheOffers: false,
	isUserTrackedAsLogged: false,
}